import '../styles/UserDetail.css';

import React, { useEffect, useState } from 'react';

import Button from '../components/atoms/Button';
import DefaultProfileImage from '../assets/profile-image-default.png';
import EditIcon from '../assets/edit-icon.svg';
import { FaTrophy } from 'react-icons/fa';
import { MdBarChart } from 'react-icons/md';
import MyPurchases from '../features/MyPurchases';
import { PURCHASE_TOGGLE } from '../constants/constants';
import PersonalDetails from '../features/PersonalDetails';
import PurchaseHistory from '../features/PurchaseHistory';
import SignInAndSecurity from '../features/SignInAndSecurity';
import UserProfileModal from './UserProfileModal.jsx';
import analyticsIcon from '../assets/analytics.png';
import purchaseIcon from '../assets/purchase.svg';
import securityIcon from '../assets/security.svg';
import useIsMobile from '../hooks/ismobile.js';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import userIcon from '../assets/black_user_icon.svg';

//import PerformaceAnalytics from './PerformanceAnalytics';

const UserDetail = () => {
	const [selectedMenu, setSelectedMenu] = useState('personalDetails'); // State to track the selected menu
	const navigate = useNavigate();
	const isMobile = useIsMobile();
	const path = '/performance-analytics';
	const achievementsPath = '/achievements';
	const { firstName, lastName, emailId, profileURL } = useSelector((state) => state.userDetails);
	const { planTierId: planTierId } = useSelector((state) => state.userDetails);
	const [tier, setTier] = useState();
	const [showUploadMoadl, setShowUploadModal] = useState(false);
	console.log('Plan Tier ID:', planTierId);
	console.log('User Profile URL:', profileURL);
	useEffect(() => {
		switch (planTierId) {
			case 'FREE_TIER':
				setTier('Freemium');
			case 'QUICK_PREP':
				setTier('Freemium');
			case 'GUIDED_LEARNER':
				setTier('Freemium');
			case 'PEAK_PREP':
				setTier('Freemium');
			default:
		}
	}, []);

	const renderContent = () => {
		switch (selectedMenu) {
			case 'personalDetails':
				return <PersonalDetails />;
			case 'signInAndSecurity':
				return <SignInAndSecurity />;
			case 'myPurchases' && PURCHASE_TOGGLE:
				return <MyPurchases />;
			case 'purchaseHistory' && PURCHASE_TOGGLE:
				return <PurchaseHistory />;
			case 'performanceAnalytics':
				return navigate(path);
			case 'achievements':
				return navigate(achievementsPath);
			default:
				return <PersonalDetails />;
		}
	};

	return (
		<div className="user-detail-container">
			{!isMobile ? (
				<React.Fragment>
					<div className="user-detail-bottom-div">
						<div className="user-profile-section">
							<div className="profile-image-container">
								<img
									src={profileURL || DefaultProfileImage}
									alt="Profile Pic"
									className="profile-image"
								/>
								<div
									className="edit-icon-overlay"
									onClick={() => setShowUploadModal(true)}
								>
									<label htmlFor="profilePicInput">
										<img src={EditIcon} alt="Edit" className="edit-icon" />
									</label>
									{/* <input
										type="file"
										id="profilePicInput"
										accept="image/*"
										style={{ display: 'none' }}
										onChange={(e) => {
											// Add logic to handle image update
											console.log('Image uploaded:', e.target.files[0]);
										}}
									/> */}
								</div>
							</div>
							<div className="profile-user-info">
								<p className="profile-name">
									{firstName} {lastName}
								</p>
								<p className="profile-email">{emailId}</p>
							</div>
							<div className="tier-section">
								<Button label={tier} className="tier-details" />
							</div>
						</div>
					</div>
					<div className="user-detail-top-div">
						<div className="column-1">
							{/* code for profile picture*/}

							<div className="user-detail-sub-menu">
								<div
									className={`user-detail-sub-menu-header ${
										selectedMenu === 'personalDetails' ? 'active' : ''
									}`}
									onClick={() => setSelectedMenu('personalDetails')}
								>
									<img src={userIcon} alt="icon" />
									<div>Personal Details</div>
								</div>
								<div
									className={`user-detail-sub-menu-header ${
										selectedMenu === 'signInAndSecurity' ? 'active' : ''
									}`}
									onClick={() => setSelectedMenu('signInAndSecurity')}
								>
									<img src={securityIcon} alt="icon" />
									<div>Sign-in & Security</div>
								</div>
								{PURCHASE_TOGGLE && (
									<div
										className={`user-detail-sub-menu-header ${
											selectedMenu === 'myPurchases' ? 'active' : ''
										}`}
										onClick={() => setSelectedMenu('myPurchases')}
									>
										<img src={purchaseIcon} alt="icon" />
										<div>My Purchases</div>
									</div>
								)}
								{PURCHASE_TOGGLE && (
									<div
										className={`user-detail-sub-menu-header ${
											selectedMenu === 'purchaseHistory' ? 'active' : ''
										}`}
										onClick={() => setSelectedMenu('purchaseHistory')}
									>
										<img src={purchaseIcon} alt="icon" />
										<div>Purchase History</div>
									</div>
								)}

								<div
									className={`user-detail-sub-menu-header ${
										selectedMenu === 'performanceAnalytics' ? 'active' : ''
									}`}
									onClick={() => setSelectedMenu('performanceAnalytics')}
								>
									<MdBarChart size={17} />
									<div>Performance Analytics</div>
								</div>

								<div
									className={`user-detail-sub-menu-header ${
										selectedMenu === 'achievements' ? 'active' : ''
									}`}
									onClick={() => setSelectedMenu('achievements')}
								>
									<FaTrophy size={15} color="#FFD700" />
									<div>Achievements</div>
								</div>
							</div>
						</div>
						<div className="column-2">{renderContent()}</div>
					</div>
				</React.Fragment>
			) : (
				<React.Fragment>
					{/* <div className="user-detail-bottom-div"></div> */}
					<div className="user-detail-top-div">
						<div className="column-1">
							<div className="user-detail-sub-menu">
								<div
									className={`user-detail-sub-menu-header ${
										selectedMenu === 'personalDetails' ? 'active' : ''
									}`}
									onClick={() => setSelectedMenu('personalDetails')}
								>
									<img src={userIcon} alt="icon" />
									<div>Personal Details</div>
								</div>
								<div
									className={`user-detail-sub-menu-header ${
										selectedMenu === 'signInAndSecurity' ? 'active' : ''
									}`}
									onClick={() => setSelectedMenu('signInAndSecurity')}
								>
									<img src={securityIcon} alt="icon" />
									<div>Sign-in & Security</div>
								</div>
								{PURCHASE_TOGGLE && (
									<div
										className={`user-detail-sub-menu-header ${
											selectedMenu === 'myPurchases' ? 'active' : ''
										}`}
										onClick={() => setSelectedMenu('myPurchases')}
									>
										<img src={purchaseIcon} alt="icon" />
										<div>My Purchases</div>
									</div>
								)}
								{PURCHASE_TOGGLE && (
									<div
										className={`user-detail-sub-menu-header ${
											selectedMenu === 'purchaseHistory' ? 'active' : ''
										}`}
										onClick={() => setSelectedMenu('purchaseHistory')}
									>
										<img src={purchaseIcon} alt="icon" />
										<div>Purchase History</div>
									</div>
								)}

								<div
									className={`user-detail-sub-menu-header ${
										selectedMenu === 'performanceAnalytics' ? 'active' : ''
									}`}
									onClick={() => setSelectedMenu('performanceAnalytics')}
								>
									<MdBarChart size={24} />
									<div>Performance Analytics</div>
								</div>

								<div
									className={`user-detail-sub-menu-header ${
										selectedMenu === 'achievements' ? 'active' : ''
									}`}
									onClick={() => setSelectedMenu('achievements')}
								>
									<FaTrophy size={20} color="#FFD700" />
									<div>Achievements</div>
								</div>
							</div>
						</div>
						<div className="column-2">{renderContent()}</div>
					</div>
				</React.Fragment>
			)}

			{showUploadMoadl && <UserProfileModal onClose={() => setShowUploadModal(false)} />}
		</div>
	);
};

export default UserDetail;
